import { generateSHA256Hash } from 'utils/generateSHA256Hash';

//Using src\helpers\generateSHA256HashLocal.js or any online platform to get this hash result
const PILOT_USER_HASHES = new Set([
  '7d2e8af0ee9f415fd377e34b004c95a609b7c2c7d5a44d9b62ce445f94b2958f',
  '48436895f99914db400279044800ea00df1191810ab566141b84f0033c5e46de',
  '1ce5223430328440c0ce5dbce14755fff0a7b4b0ddefe1c1ebc2757bfb84e1be',
  '2665f07dbe950bdd9b851ede6e9808286c725fcf7736573434df6558689060bc',
  '6b038def5438687274321c9bdd0b7853d359d8408b55a707a2c43699c89828ca',
  '0fcab4979dd08c154f992462d471737aac75c934d49790f2175cd59a14ab8c8f',
  'f7152259063d335a3357b8ba22db4a812403e4c319af11ac6d1a500cd7387b7f',
  '620da28b090019cfa39fbd16822725d462f05d6f6e5f4a7e44f62a2d0d8a98b7',
  '8366d4510782e5542b8002ae2556a2c73be78cb56a6363240e11249612ec8a9e',
  'bb25549b6d2243d77a276f75e1db5976be68209539ac9f54863c08270c834b50',
  '1d4e2032c545158178145061406663373452687a9e21cc73344a24ad5b0df750',
  '12d19f405982f260701f571f7e34b91afca26405556dda15a69aa6411c36e3d1',
  '779ebe5fb2dbe74bde0089072423249699eb8095629c05b087904962cd43cd8a',
  'd674039c790bb3f9f545bfaaeee19e7b19cf25242523e11df5b18a08fe77e527',
  '8527d8530e2a5690eb43aebb51f6dd9e4a3bfe4d3f16b2bc18b4edb6958ebf73',
  'f739db09fd8f6b8b4f91ba66867545c37feaab9b81b4df6c8fea51a42125846e',
  'a9ebde9147fe523d0b7d13f3dabf009f61360a1fb8b265fa020a630d73fb305c',
  '70d2885b2fffe01c17041b5f6ac7e4e7f389a2775325a6d2c2d36310040f953f',
  '0aacbdfb4e3940e5bdeb2b0fd4d511f487c7dd3a7db2d54acb253de9e4a308af',
  '7c5fc7ae42b483ec697523cdde9de8d300fb712d15cedbbfd7e93abcdfc86cc3',
  'b9c5086921af661ee6e171b2d8fbbf361e581e05127931f2a8c2e47ffe1dc59b',
  '4838dcb13ccdab2236291a3875fbfeccef2193c7124d5043c634120dde62ab38',
  '80ce51e8708a90c8407f2209ebc5a137f2f29a4253ad050619006b91116d56f0',
  '8df0b4a1cd5144ba96e701c747a5597ec949f8d9f807b36c9f44b3f62a72b933',
  'f16506ece338adc69669c5f29657e0050fda8af03f45afe1f16a603415ee4a84',
  'b37d6084755f68d6cf78158568b203993a6540b098049fe3739e09123d4f31d9',
  '15abf63db7ea888830d0d5332cdc4c394029c47c42c288fa4bbf567eec88c282',
  '248d43fdb8840609e5a56cbacd0af72860f128b6cc147c7e5e3b560bd65127f4',
  'e10a3b1ce9e8c52333c6cc953d107fe1d2a41032dfcaf4574394fc1be28cc0ef',
  'f6204cf93e0f43f1a20cd2e5018c29de3744ad5d0072673d413d5ff55486212d', // matthewdns@gmail.com <= Chau's account test
  '055a34b5fd5ec95fbf71bf2deb35b507b8f5a85e43db6f0201a2d01b2359dcb1',
  '0849bae44c0e438699b4fcf6ade9823bf286e6dc108f4cafc6301dec4636f00a',
  'a9ae7f33ae2a7e6654c05515b8051ea1db87522c05bc8f2ad8b6820e1f1c6959',
]);

export const isPilotUser = async (email: string) => {
  // Normalize email to lowercase and trim whitespace
  const normalizedEmail = email.toLowerCase().trim();

  // Create SHA-256 hash of the email using Web Crypto API
  const emailHash = await generateSHA256Hash(normalizedEmail);

  // Check if hash exists in the pilot user set
  return PILOT_USER_HASHES.has(emailHash);
};
